import { createSelector, createSlice, current } from '@reduxjs/toolkit';
import attributeItemData from '../../public/attributeitems.json';

const initialState = {
  items: [],
};


const attributeItemSlice = createSlice({
  name: 'attributeItems',
  initialState,
  reducers: {
    /**
     * 初期値を読み込み
     * 
     * @param {*} state 
     * @param {*} action 
     */
    loadAttributeItemData(state, action) {
      const payload = action.payload;

      let loadedItems = [];
      if (Array.isArray(payload)) {
        loadedItems = payload;
      } else {
        loadedItems = attributeItemData || [];
      }

      const itemDefault = {
        tagName: '',
        attributes: [],
        events: [],
        idTypeComment: ''
      };

      const commonIndex = loadedItems.findIndex(i => i.tagName === '@common_element@');
      if (commonIndex !== -1) {
        if (!loadedItems[commonIndex].attributes) loadedItems[commonIndex].attributes = [];
        const commonAttrs = loadedItems[commonIndex].attributes;
        if (!commonAttrs.some(a => Object.keys(a)[0] === 'style-spacing')) {
          commonAttrs.push({
            'style-spacing': {
              inputName: 'style-spacing',
              inputType: '',
              options: [],
              registerType: 'system'
            }
          });
        }
        if (!commonAttrs.some(a => Object.keys(a)[0] === 'style-typography')) {
          commonAttrs.push({
            'style-typography': {
              inputName: 'style-typography',
              inputType: '',
              options: [],
              registerType: 'system'
            }
          });
        }
        if (!commonAttrs.some(a => Object.keys(a)[0] === 'style-border')) {
          commonAttrs.push({
            'style-border': {
              inputName: 'style-border',
              inputType: '',
              options: [],
              registerType: 'system'
            }
          });
        }
        if (!commonAttrs.some(a => Object.keys(a)[0] === 'style-shadow')) {
          commonAttrs.push({
            'style-shadow': {
              inputName: 'style-shadow',
              inputType: '',
              options: [],
              registerType: 'system'
            }
          });
        }
        if (!commonAttrs.some(a => Object.keys(a)[0] === 'style-sizing')) {
          commonAttrs.push({
            'style-sizing': {
              inputName: 'style-sizing',
              inputType: '',
              options: [],
              registerType: 'system'
            }
          });
        }
        if (!commonAttrs.some(a => Object.keys(a)[0] === 'style-background')) {
          commonAttrs.push({
            'style-background': {
              inputName: 'style-background',
              inputType: '',
              options: [],
              registerType: 'system'
            }
          });
        }
      }

      state.items = loadedItems
        // 1. アイテム自体の生存確認
        .filter(item => item && typeof item === 'object')
        .map(item => ({
          ...itemDefault,
          ...item,
          // 2. 【重要】attributes配列の中身も生存確認 (Selectorでの Object.keys(null) 防止)
          attributes: Array.isArray(item.attributes)
            ? item.attributes.filter(a => a && typeof a === 'object')
            : [],
          // 3. events配列の中身も生存確認
          events: Array.isArray(item.events)
            ? item.events.filter(e => e && typeof e === 'object')
            : []
        }));
    },
    /**
     * 既存のタグに属性を追加
     * 
     * @param {*} state 
     * @param {*} action 
     */
    addAttributeToExistingTag(state, action) {
      const { tagName, attribute } = action.payload;
      const tag = state.items.find(item => item.tagName === tagName);
      if (tag) {
        let a = current(tag.attributes);
        tag.attributes = [...tag.attributes, attribute];
      }
    },
    /**
     * 属性を編集
     * 
     * @param {*} state 
     * @param {*} 
     */
    modifyAttribute(state, action) {
      const { tagName, attributeKey, attributeValue } = action.payload;
      const tag = state.items.find(item => item.tagName === tagName);
      if (tag) {
        let attribute = tag.attributes.find(item => {

          return Object.keys(item)[0] === attributeKey
        });
        let oldAttributeValue = attribute[attributeKey];
        let newAttributeValue = {
          ...oldAttributeValue,
          ...attributeValue
        }
        attribute[attributeKey] = newAttributeValue;
      }
    },
    /**
     * 新しいタグを追加
     * 
     * @param {*} state 
     * @param {*} action 
     */
    addNewTag(state, action) {
      const { tagName, attributes } = action.payload;
      const newTag = {
        tagName,
        attributes: [
          ...state.items.find(item => item.tagName === '@common_element@').attributes,
          ...attributes
        ]
      };
      state.items.push(newTag);
    },
    /**
     * 既存のタグから属性を削除
     * 
     * @param {*} state 
     * @param {*} action 
     */
    removeAttributeFromExistingTag(state, action) {
      const { tagName, attributeKey } = action.payload;
      const tag = state.items.find(item => item.tagName === tagName);
      if (tag) {
        tag.attributes = tag.attributes.filter(attribute => Object.keys(attribute)[0] !== attributeKey);
      }
    },
    /**
     * 既存のタグを削除
     * 
     * @param {*} state 
     * @param {*} action 
     */
    removeExistingTag(state, action) {
      const tagName = action.payload;
      state.items = state.items.filter(item => item.tagName !== tagName);
    },
    /**
     * 属性の並び順を変更
     * @param {*} state 
     * @param {*} action 
     */
    changeAttributeOrder(state, action) {
      const { tagName, attributeKey, newIndex, attributes } = action.payload;
      const tag = state.items.find(item => item.tagName === tagName);
      if (tag) {
        let newAttributes = [...attributes];
        let attribute = newAttributes.find(item => {
          return Object.keys(item)[0] === attributeKey
        });
        newAttributes.splice(newAttributes.indexOf(attribute), 1);
        newAttributes.splice(newIndex, 0, attribute);
        tag.attributes = newAttributes;

        // //state.itemからtagを探して、newAttributesを差し替える
        // for (let index = 0; index < state.items.length; index++) {
        //   const element = state.items[index];
        //   if (element.tagName === tagName) {
        //     element.attributes = newAttributes;
        //   }
        // }

      }
    },
    /**
     * 特定のスクリプトによって追加されたカスタム属性をすべて削除する
     * @param {*} state
     * @param {payload: { originScriptName: string }} action
     */
    removeAttributesByScript(state, action) {
      const { originScriptName } = action.payload;
      state.items.forEach(tag => {
        if (tag.attributes) {
          //let aaa = current(tag);
          //let bbb = current(tag.attributes);
          tag.attributes = tag.attributes.filter(attr => {
            //let aab = current(attr);
            // registerTypeが'customScript'で、originScriptNameが一致するものを削除
            return !(Object.values(attr)[0].registerType === 'customScript' &&
              Object.values(attr)[0].originScriptName === originScriptName)
          }
          );
        }
      });
    },
    /**
     * タグの型定義コメント(idTypeComment)を追加または更新する
     * @param {*} state
     * @param {*} action - payload: { tagName: string, idTypeComment: string }
     */
    setIdTypeCommentForTag(state, action) {
      const { tagName, idTypeComment } = action.payload;
      const tag = state.items.find(item => item.tagName === tagName);
      if (tag) {
        // 既存のタグにidTypeCommentプロパティを追加/更新
        tag.idTypeComment = idTypeComment;
      } else {
        // タグ定義がまだ存在しない場合（念のため）、新しいタグとして追加
        // 実際には syncUserScriptComponents などでタグ自体は先に作られているはず
        const commonAttrs = state.items.find(item => item.tagName === '@common_element@')?.attributes || [];
        state.items.push({
          tagName: tagName,
          attributes: [...commonAttrs],
          idTypeComment: idTypeComment,
        });
      }
    },
  },
});

// stateからattributeItemsを取得するセレクター
const selectAttributeItems = state => state.attributeItems;

export const selectAttributeByTagName = createSelector(
  // 第一引数には入力セレクターの配列を渡す
  [selectAttributeItems, (state, tagName) => tagName],
  // 第二引数には出力セレクターの関数を渡す
  (attributeItems, tagName) => {
    let element = attributeItems.items.find(e => e.tagName === tagName);
    // エレメントが見つからなければ基本の配列を返す
    if (element === undefined || element === null) return [];

    // 未編集（デフォルト）の状態であるかチェック
    // 属性定義のキーに「@common_element@」などのプレースホルダーが含まれているかを判定します
    const isDefaultState = element.attributes.some(att => {
      const key = Object.keys(att)[0];
      return key.startsWith("@") && key.endsWith("@");
    });

    // エレメントのattributesをコピーする
    let attributes = [...element.attributes];
    // attributesの各キーについて、他のtagNameと一致するものがあれば展開する
    // 後ろ側からループする
    for (let index = attributes.length - 1; index >= 0; index--) {
      const att = attributes[index];
      //const key = Object.keys(att)[0]
      const key = Object.keys(att)[0]
      // キーが@で始まり@で終わる場合、他のtagNameとみなす
      if (key.startsWith("@") && key.endsWith("@")) {
        let otherTagName = key;
        // tagNameと一致するエレメントを探す
        let otherElement = attributeItems.items.find(e => e.tagName === otherTagName);
        // エレメントが見つかれば、そのattributesを展開する
        if (otherElement) {
          // 展開前のキーを削除する
          attributes.splice(index, 1);
          // 展開後のキーと値を挿入する
          attributes.splice(index, 0, ...otherElement.attributes);
        }
      }
    }
    // ユーザーが一度手動で並び替えている場合はこの処理をスキップし、保存されたカスタム位置を維持します
    if (isDefaultState) {
      // 以下のように orderKeys の配列を使って一括で順序を整えるよう書き換えます
      const orderKeys = [
        'style-sizing',       // 1. サイズ（骨組み）
        'style-spacing',      // 2. 余白（位置・バランス）
        'style-typography',   // 3. タイポグラフィ（可読性）
        'style-background',   // 4. 背景・不透明度（面の装飾）
        'style-border',       // 5. ボーダー・角丸（枠の装飾）
        'style-shadow'        // 6. シャドウ（仕上げ・奥行き）
      ];

      orderKeys.forEach(key => {
        const idx = attributes.findIndex(attr => Object.keys(attr)[0] === key);
        if (idx !== -1) {
          const [attr] = attributes.splice(idx, 1);
          attributes.push(attr);
        }
      });
    }
    // 展開後のattributesを返す
    return attributes;
  });

/**
 * state.attributeItems.itemsの中身から、tagNameを無視してatteributesをすべて取得し、タグ名でサマリーするメソッド
 */
export const selectAttributeList = createSelector(
  selectAttributeItems,
  attributeItems => {
    let items = attributeItems.items.filter(item => item.tagName !== '@common_element@');
    let attributes = items.map(item => item.attributes).flat();
    attributes = attributes.filter(attribute => !(Object.keys(attribute)[0].startsWith("@") && Object.keys(attribute)[0].endsWith("@")));
    attributes = attributes.reduce((acc, cur) => {
      let key = Object.keys(cur)[0];
      if (acc[key]) {
        acc[key].push(cur[key]);
      } else {
        acc[key] = [cur[key]];
      }
      return acc;
    }, {});

    attributes = Object.keys(attributes).reduce((acc, cur) => {
      acc[cur] = attributes[cur].filter((item, index, array) => {
        return array.findIndex(item2 => {
          return JSON.stringify(item) === JSON.stringify(item2);
        }) === index;
      });
      return acc;
    }, {});

    return attributes;
  });

//タグ名を指定してオブジェクトを返すセレクター
export const selectByTagName = createSelector(
  selectAttributeItems,
  (state, tagName) => tagName,
  (attributeItems, tagName) => {
    let tag = attributeItems.items.find(item => item.tagName === tagName);
    return tag;
  }
)




export const { loadAttributeItemData, addAttributeToExistingTag, addNewTag, removeAttributeFromExistingTag, removeExistingTag, changeAttributeOrder, modifyAttribute, removeAttributesByScript, setIdTypeCommentForTag } = attributeItemSlice.actions;
export default attributeItemSlice.reducer;
